import { useRef, useState } from "react";
import toast from "react-hot-toast";
import moment from "moment";

export default function Filter({ records = 0, search, onFilter }) {
  const searchRef = useRef();

  const [start, setStart] = useState(
    moment().startOf("week").format("YYYY-MM-DD")
  );
  const [end, setEnd] = useState(moment().endOf("week").format("YYYY-MM-DD"));

  const [searchTerm, setSearchTerm] = useState("");

  const handleFilter = () => {
    try {
      onFilter?.({
        start,
        end,
      });
    } catch {
      toast.error("Invalid selection");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 16px",
        background: "var(--background)",
        color: "var(--text)",
      }}
    >
      {/* LEFT SIDE */}
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <div
          className="px-3 py-1 rounded-full text-sm font-medium"
          style={{
            background: "var(--background)",
            border: "2px solid var(--hover)",
            color: "var(--text)",
          }}
        >
          Records: {records || 0}
        </div>

        <input
          ref={searchRef}
          type="text"
          placeholder="Search Symbol"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            search?.(e.target.value);
          }}
          className="w-[180px] px-4 py-1 rounded-full text-sm focus:ring-2 outline-none"
          style={{
            background: "var(--background)",
            border: "2px solid var(--hover)",
            color: "var(--text)",
          }}
        />
      </div>

      {/* RIGHT SIDE */}
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        {/* DATE PICKERS */}
        <input
          type="date"
          value={start}
          max={moment().format("YYYY-MM-DD")}
          onChange={(e) => setStart(e.target.value)}
          style={{
            background: "var(--background)",
            border: "2px solid var(--hover)",
            color: "var(--text)",
            padding: "6px 10px",
            borderRadius: "6px",
          }}
        />

        <input
          type="date"
          value={end}
          max={moment().format("YYYY-MM-DD")}
          onChange={(e) => setEnd(e.target.value)}
          style={{
            background: "var(--background)",
            border: "2px solid var(--hover)",
            color: "var(--text)",
            padding: "6px 10px",
            borderRadius: "6px",
          }}
        />

        {/* FILTER BTN */}
        <button
          onClick={handleFilter}
          className="px-4 py-1.5 bg-[var(--primary)] text-white rounded-full text-sm font-semibold shadow"
        >
          Filter
        </button>
      </div>
    </div>
  );
}
